import Proptypes from 'prop-types';

import { MENTION_DEFINITIONS } from '@xing-com/content-editor-plugin-helpers';

import { Styled } from './Mention.style';

const renderer = ({ node: { type, data }, className, ...attributes }) => {
  if (type === MENTION_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;

    return (
      <Styled.ViewerMention
        {...restOfAttributes}
        className={className}
        href={`/profile/${data?.user?.pageName}`}
        target="_self"
      >
        {children}
      </Styled.ViewerMention>
    );
  }
};

renderer.proptypes = {
  node: Proptypes.object,
  attributes: Proptypes.object,
  className: Proptypes.string,
};

export { renderer };
